import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Consts from '../constants';

let widget = null; //store one widget instance so it can be reused across <UploadButton/> usage

export default class UploadButton extends Component {

  static propTypes = {
    onResult: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    let opts = {
      cloudName: Consts.CLOUD_NAME,
      uploadPreset: 'demopage',
      theme: 'white',
      multiple: true,
      maxFiles: 5,
      resourceType: 'image',
      googleApiKey: 'AIzaSyAugh8ddeFTt5ckj9rFcRKNHxem18hKiRo',
      searchBySites: ['all', 'nytimes.com'],
      autoMinimize: true,
    };

    if (!widget) {
      widget = cloudinary.openUploadWidget( //eslint-disable-line no-undef
        opts,
        (error, result) => {
          if (result && result.event === 'success') {
            this.props.onResult(result.info);
          }
        }
      );
    }
    else {
      widget.open();
    }

    e.preventDefault();
  }

  render() {
    return (
      <a href="#" onClick={this.handleClick} className="btn btn-info btn-upload-image">Upload your image</a>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/UploadButton.js
 **/